import { render, staticRenderFns } from "./TrainingForm.vue?vue&type=template&id=1180f6a0&scoped=true"
import script from "./TrainingForm.vue?vue&type=script&lang=js"
export * from "./TrainingForm.vue?vue&type=script&lang=js"
import style0 from "./TrainingForm.vue?vue&type=style&index=0&id=1180f6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1180f6a0",
  null
  
)

export default component.exports